module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTQuMTY2IiBoZWlnaHQ9IjQyNy44NCIgdmlld0JveD0iMCAwIDUxNC4xNjYgNDI3Ljg0Ij4KICA8cGF0aCBpZD0i44OR44K5XzM2MDMiIGRhdGEtbmFtZT0i44OR44K5IDM2MDMiIGQ9Ik0tMjg1Ljg4LDQ1Mi4wODNWMjE5LjExOUwyMjguMjg2LDI0LjI0NFYyNTcuMjA4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjg1Ljg4MSAtMjQuMjQ0KSIgZmlsbD0iYmx1ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/blue_514.svg
// module id = kQrQ
// module chunks = 0